import asModule from '$app-web/hoces/as-module';
import { URLsManager } from '$app-web/utils';
import lazyLoad, { withTimeoutAndDelay } from '$app-web/utils/lazy-load';

// TODO: This should be on the routes/index.js preferably.
URLsManager.space('dashboard').addModule('rdash').setURLs({
    HOME: '/',
    LICENSE_MANAGEMENT: '/license-management/',
    MY_STUDIES: '/my-studies/',
    CREATE_STUDY: '/create-study/',
    STUDY_LICENSE: '/study/:studyId/license/',
    STUDY_BASICS: '/study/:studyId/basics/',
    STATISTICS: '/study/:studyId/statistics/',
    ACTIVITIES: '/study/:studyId/activities/',
    DATA_SOURCES: '/study/:studyId/data-sources/',
    RESEARCHERS: '/study/:studyId/researchers/',
    ROLES: '/study/:studyId/roles/',
    APPOINTMENT_TYPES: '/study/:studyId/appointment-types/',
    APPOINTMENTS: '/study/:studyId/appointments/',
    PARTICIPATION: '/study/:studyId/participation/',
    PARTICIPATION_PENDING_INVITATION: '/study/:studyId/participation-pending-invitation/',
    PARTICIPATION_STATS: '/study/:studyId/participation-stats/',
    PARTICIPATION_PERMISSIONS: '/study/:studyId/participation-permissions/',
    DATA_EXPORT: '/study/:studyId/data-export/',
    BEACONS: '/study/:studyId/data-sources-beacons/',
    ACTIVITY_SESSIONS: '/study/:studyId/activity-sessions/',
    ACTIVITY_RESPONSES: '/study/:studyId/activity-responses/',
    ACTIVITY_SINGLE_SESSION: '/study/:studyId/activity-sessions/:sessionUUID',
    SURVEY_RESPONSES: '/study/:studyId/survey-responses/',
    SETTINGS_PERSONAL_INFORMATION: '/settings/personal-information',
    SETTINGS_SECURITY: '/settings/security',
    SETTINGS_NOTIFICATIONS: '/settings/notifications',
    SETTINGS_AVAILABILITY: '/settings/availability',
    PHR: '/study/:studyId/phr/',
    AUDIT_TRAIL: '/study/:studyId/audit-trail/',
    AUDIT_TRAIL_V2: '/study/:studyId/audit-trail-v2/',
    CHAT: '/study/:studyId/chat/',
    RECORDINGS: '/study/:studyId/recordings/',
    NOTIFICATIONS: '/study/:studyId/notifications/',
    NOTIFICATION_TEMPLATES: '/study/:studyId/notification-templates/',
    SUMMARY_TABLES: '/study/:studyId/summary-tables/',
    SENSOR_DATA_VISUALIZATIONS: '/study/:studyId/sensor-data-visualizations/',
    ENGAGEMENT_OPTIONS: '/study/:studyId/engagement-options/',
    AI_COHORTS: '/study/:studyId/ai-cohorts/',
    AI_COHORT_SIMULATION: '/study/:studyId/ai-cohorts/:cohortId/simulation/:simulationId/',
    AI_ASSISTANT: '/study/:studyId/ai-assistant/',
    DATASETS: '/study/:studyId/datasets/:root/',
    PROGRESS_REWARD_CONTENT: '/study/:studyId/progress-reward/content/',
    PROGRESS_REWARD_PUBLISH: '/study/:studyId/progress-reward/publish/',
    // Researcher-defined pages. The `custom-page/` prefix keeps authored slugs from colliding with
    // the hand-enumerated routes above.
    CUSTOM_PAGE: '/study/:studyId/custom-page/:slug/',
});

const RdashModule = lazyLoad(() => withTimeoutAndDelay(() => import('./module')));

function shouldRender({ user }) {
    return user.isAuthenticated && user.role === 'researcher' && user.initializationStatusSucceeded;
}

export default asModule(shouldRender, 'dashboard.rdash')(RdashModule);
